module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_chapel@3x-14cfb8b9fb05043d3716d41644e80335.webp";